export enum ProductProcessorsEnum {
  FIX_ATTR_BOOL_VALUES = 'fix_attr_bool_values',
  AUTOPICK = 'autopick',
  SIZE = 'size',
  DELIVERY_SHEET_SIZES = 'delivery_sheet_sizes',
  COLOR = 'color',
  DELIVERY_ROLL = 'delivery_roll',
  OUT_OF_STOCK = 'out_of_stock',
}
